export default {
   'hour': {
        'zh':'时',
        'en':'H'
   },
   'minute': {
        'zh':'分',
        'en':'M'
   },
   'second': {
        'zh':'秒',
        'en':'S'
   }
}


// WEBPACK FOOTER //
// ./src/Locale/n3Timepicker.js